// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__6w7Mi","signup":"Signup_signup__CAn4u","error":"Signup_error__DeEo9"};